module.exports = __webpack_public_path__ + "img/right.c93d0365.png";